import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import DateComp from "@/components/public/DateComp";
import ServeDialog from "@/components/statistical/ServeDialog";
export default {
  name: "UserView01",
  components: {
    DateComp: DateComp,
    ServeDialog: ServeDialog
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      startDate: "",
      endDate: "",
      deptId: "",
      pageNum: 1,
      pageSize: 20,
      total: 0,
      headCount: {
        serveQuantity: 0,
        servicePersonNum: 0,
        serveNum: 0,
        endNum: 0,
        endRate: "",
        avgTakeTime: "",
        avgAppraiseScore: ""
      },
      list: []
    };
  },
  computed: _objectSpread({}, mapGetters(["userData"])),
  created: function created() {},
  mounted: function mounted() {
    this.initPage();
  },
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      var date = this.$refs.date.getValue();
      this.$http.post("serveCount/byPersonal", JSON.stringify({
        startDate: date[0],
        endDate: date[1],
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == "0") {
          _this.headCount.serveQuantity = data.resData.serveCountSurvey.serveQuantity;
          _this.headCount.servicePersonNum = data.resData.serveCountSurvey.servicePersonNum;
          _this.headCount.serveNum = data.resData.serveCountSurvey.serveNum;
          _this.headCount.endNum = data.resData.serveCountSurvey.endNum;
          _this.headCount.endRate = data.resData.serveCountSurvey.endRate;
          _this.headCount.avgTakeTime = data.resData.serveCountSurvey.avgTakeTime;
          _this.headCount.avgAppraiseScore = data.resData.serveCountSurvey.avgAppraiseScore;
          _this.list = data.resData.countPage.list;
          _this.total = data.resData.countPage.total;
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    initPage: function initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage: function changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showSearchView: function showSearchView() {
      this.$refs.serveDialog.showView();
    }
  },
  watch: {},
  filters: {
    costTimeH: function costTimeH(value) {
      if (!value) return "-";
      var time = Math.floor(value / 1000);
      var day = Math.floor(time / (3600 * 24));
      var hour = Math.floor((time - day * 3600 * 24) / 3600);
      var min = Math.floor((time - day * 3600 * 24 - hour * 3600) / 60);
      var str = "";

      if (day > 0) {
        str += day + "天";
      }

      if (hour > 0) {
        str += hour + "时";
      }

      if (str == "") {
        str += min + "分";
      }

      return str;
    }
  }
};